/** Whether a speech API failure should fall back to browser Web Speech synthesis. */
export function shouldFallbackToBrowserSpeech(err: unknown): boolean {
  if (
    typeof err === "object" &&
    err !== null &&
    "response" in err &&
    (err as { response?: { status?: number } }).response != null
  ) {
    const status = (err as { response: { status: number } }).response.status;
    // Only fall back when the route is missing (local dev rollout). Surface auth
    // failures and configured-provider outages instead of silently using browser TTS.
    if (status === 401 || status === 403 || status === 502 || status === 503) {
      return false;
    }
    return status === 404;
  }
  return true;
}
